import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

/**
 * Reusable info tooltip: a small info icon that reveals a hint on hover/tap.
 *
 * @param {React.ReactNode} title    Tooltip content (text or node).
 * @param {string}          placement MUI Tooltip placement (default "top").
 * @param {"small"|"inherit"|"medium"|"large"} size Icon size (default "small").
 * @param {object}          sx       Extra styles for the icon.
 */
const InfoTooltip = ({ title, placement = "top", size = "small", sx = {} }) => {
  if (!title) return null;

  return (
    <Tooltip title={title} placement={placement} arrow>
      <IconButton
        size={size}
        sx={{ p: 0.25, color: "text.secondary", ...sx }}
        aria-label={typeof title === "string" ? title : "more info"}
      >
        <InfoOutlinedIcon fontSize={size} />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;
